import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_REQUEST_LIST_BY_C_IN_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_REQUEST_QUERY = graphql(
	/* GraphQL */ `
		query ReservationRequestListByCInDateForManagementReservationSearchRequest(
			$hotelID: ID!
			$to: String!
			$reservationRequestStatus: ReservationRequestStatus!
			$from: String!
		) {
			reservationRequestListByCInDate(
				hotelID: $hotelID
				to: $to
				reservationRequestStatus: $reservationRequestStatus
				from: $from
			) {
				id
				hotelID
				hotelPrefecture
				hotelName
				reservations {
					hotelID
					reservationID
					reservationType
					repeaterType
					reservationStatus
					guestName
					guestNameKana
					guestTel
					guestEmail
					guestPostalCode
					guestAddress
					checkIn
					checkInTimeStart
					checkInTimeEnd
					checkOut
					reserveDate
					latestUpdateDate
					canceledDate
					numOfPeople
					numOfAdult
					numOfKids
					numOfRoom
					plan
					planCanceled
					room {
						roomID
						name
						date
						numOfPeople {
							adultNum
							kidsNum {
								age
								asCosleeping
							}
							uniqueRoomID
						}
					}
					roomCanceled {
						roomID
						name
						date
						numOfPeople {
							adultNum
							kidsNum {
								age
								asCosleeping
							}
							uniqueRoomID
						}
					}
					option {
						optionID
						name
						date
						amount
					}
					optionCanceled {
						optionID
						name
						date
						amount
					}
					discount
					questions {
						question
						answer
					}
					vouchers {
						name
						price
					}
					paymentMethod
					totalGuestCharge
					pricePlanTotal
					priceRoomTotal
					priceOptionTotal
					priceAdditionalFeeTotal
					priceDiscount
					isAcceptMailMagazine
					isNoShow
					memoByHost
					createdAt
				}
			}
		}
	`,
);
